<div class="grid-container">
    <div class="grid-item" *ngFor="let icon of icons">
        <img [src]="baseUrl + icon.image.image" class="item-img" alt="icon"/>
        <span class="item-description">{{icon.text}}</span>
    </div>
</div>